import { sensitiveViewPlaintext } from '@/api/user';
import { containsSensitivePlaceholder } from '@/utils/sensitiveData';
import { uploadOos } from '@/utils/ali_oos_util';
import { imgTypeArr, pdfTypeArr } from '@/enums/evaluateEnums';
import { apiCustomerFindById, getCustomerParentOptions, getCustomerTimeList } from '@/api/customer';
import { cloneDeep } from 'lodash-es';
export default {
  clearSensitiveForm() {
    this.sensitiveVersion++;
    this.sensitiveReady = false;
    this.fileList = [];
    this.resetRuleForm();
  },
  async getRecordField() {
    const resCus = await getCustomerTimeList('customer_source');
    const resMode = await getCustomerTimeList('fulfillment_mode');
    if (resCus.data) {
      this.resCusList = resCus.data;
    }
    if (resMode.data) {
      this.resModeList = resMode.data;
    }
  },
  async changeLevel(val) {
    this.ruleForm.parentId = '';
    this.ruleForm.channel = '';
    if (val && val !== 1) {
      this.rules.parentId = [
        {
          required: true,
          message: this.$t('GlobalSetObj.pleaseChoose'),
          trigger: ['blur', 'change']
        }
      ];
      const dataVal = val === 2 ? 1 : 2;
      const result = await getCustomerParentOptions(dataVal);
      this.parentAccountList = result.data;
    } else {
      this.rules.parentId = [
        {
          required: false,
          message: this.$t('GlobalSetObj.pleaseChoose'),
          trigger: ['blur', 'change']
        }
      ];
    }
  },
  getParentOptions(val) {
    if (val) {
      const obj = this.parentAccountList.find((item) => item.id === val);

      this.ruleForm.channel = obj.channel;
    } else {
      this.ruleForm.channel = '';
    }
  },
  handleUsernameInput(value) {
    if (!value) return;
    // 实时处理输入：过滤空格、转小写、限制特殊字符
    let processedValue = value.replace(/\s/g, '').toLowerCase();
    if (processedValue.length > 30) {
      processedValue = processedValue.substring(0, 30);
    }
    this.ruleForm.username = processedValue;
  },
  handleChange(val) {

  },
  resetRuleForm() {
    for (const key in this.ruleForm) {
      this.ruleForm[key] = '';
    }
    this.ruleForm.source = 'corporation';
    this.ruleForm.auditState = 0;
    this.ruleForm.lockState = 1;
    this.ruleForm.integral = '0';
    this.syncSenderAddress = false;
  },
  changeSource() {
    this.ruleForm.identityCard = '';
    if (this.ruleForm.source !== 'corporation') {
      this.syncSenderAddress = false;
    }
  },
  getCustomerData(ids) {
    const version = ++this.sensitiveVersion;
    const identity = this.sensitiveIdentity;
    this.sensitiveReady = false;
    this.sensitiveError = '';
    return apiCustomerFindById(ids)
      .then(async(res) => {
        if (version !== this.sensitiveVersion || identity !== this.sensitiveIdentity) return;
        if (res.code !== 200) throw new Error(this.$t('sensitiveView.failed'));
        let data = res.data;
        if (!this.readonly) {
          if (!this.canEditSensitive) {
            this.readonly = true;
            this.sensitiveError = this.$t('sensitiveView.forbidden');
          } else {
            data = (await sensitiveViewPlaintext({ data })).data;
          }
        }
        if (version !== this.sensitiveVersion || identity !== this.sensitiveIdentity || (!this.readonly && !this.canEditSensitive)) return;
        // 处理证件照附件
        const attachment = data.identityCardAttachment;
        this.fileList = [];
        if (attachment?.includes('http')) {
          attachment.split(',').forEach((url) => {
            try {
              const urlObj = new URL(url);
              const fileNameEncoded = urlObj.pathname.split('/').pop();
              const fileNameDecoded = decodeURIComponent(fileNameEncoded);
              const cleanedName = fileNameDecoded
                .replace(/\d{8}T\d{6}/g, '')
                .replace(/[-_]+(?=\.)/g, '');

              this.fileList.push({ name: cleanedName, url });
            } catch (error) {
              this.sensitiveError = this.$t('sensitiveView.failed');
            }
          });
        }
        this.changeLevel(data.level);
        const formData = {
          id: data.id,
          source: data.source,
          company: data.company,
          coPrincipalName: data.coPrincipalName,
          coPrincipalPhone: data.coPrincipalPhone,
          coPrincipalTel: data.coPrincipalTel,
          coPrincipalEmail: data.coPrincipalEmail,
          coPrincipalQq: data.coPrincipalQq,
          address: data.address,
          identityCard: data.identityCard,
          packageDeviation: data.packageDeviation,
          identityCardAttachment: data.identityCardAttachment,
          logisticsContactsName: data.logisticsContactsName,
          logisticsContactsPhone: data.logisticsContactsPhone,
          logisticsContactsTel: data.logisticsContactsTel,
          logisticsContactsEmail: data.logisticsContactsEmail,
          logisticsContactsQq: data.logisticsContactsQq,
          reverseType: data.reverseType,
          ftpUploadPath: data.ftpUploadPath,
          username: data.username,
          password: '',
          code: data.code,
          siteId: data.siteId,
          customerPhone: data.customerPhone,
          customerEmail: data.customerEmail,
          auditState: data.auditState,
          lockState: data.lockState,
          customerAlias: data.customerAlias,
          integral: data.integral || '0',
          handlerIdList: data.handlerIdList,
          ftpHost: data.ftpHost,
          ftpUsername: data.ftpUsername,
          ftpPassword: data.ftpPassword,
          ftpPort: data.ftpPort,
          ftpPath: data.ftpPath,
          ftpType: data.ftpType,
          orderNumberType: data.orderNumberType,
          cnpjMother: data.cnpjMother,
          cnpjSon: data.cnpjSon,
          ieNumber: data.ieNumber,
          zipcode: data.zipcode,
          houseNumber: data.houseNumber,
          complement: data.complement,
          street: data.street,
          city: data.city,
          state: data.state,
          isTrackStopAlert: data.isTrackStopAlert,
          trackStopAlertDays: data.trackStopAlertDays,
          coPrincipalIdentityCard: data.coPrincipalIdentityCard,
          productRequirement: data.productRequirement,
          channel: data.channel,
          level: data.level,
          parentId: data.parentId,
          deliveryNoteFlag: data.deliveryNoteFlag,
          customerSource: data.customerSource,
          fulfillmentMode: data.fulfillmentMode
        };
        this.$nextTick(() => {
          if (version !== this.sensitiveVersion || identity !== this.sensitiveIdentity || (!this.readonly && !this.canEditSensitive)) return;
          Object.assign(this.ruleForm, formData);
          this.sensitiveReady = this.canEditSensitive && !this.readonly;
        });
        // 其他页签只接收自身所需配置，避免持有已解密的客户联系信息。
        const settings = {};
        ['id', 'ftpHost', 'ftpUsername', 'ftpPassword', 'ftpPort', 'ftpPath', 'ftpType', 'ftpUploadPath',
          'orderNumberType', 'deliveryNoteFlag', 'isTrackStopAlert', 'trackStopAlertDays', 'reverseType']
          .forEach(key => { settings[key] = data[key]; });
        this.$emit('updataAuthorizationCode', data.authorizationCode || '', settings);
      })
      .catch(() => {
        if (version === this.sensitiveVersion) this.sensitiveError = this.$t('sensitiveView.failed');
      });
  },
  onEditBtn() {
    if (!this.canEditSensitive) return;
    this.customerTypeSee.type = 'edit';
  },
  onSubmit(formName) {
    if (this.customerTypeSee.type !== 'add' && (!this.sensitiveReady || !this.canEditSensitive)) {
      this.$message.warning(this.$t('sensitiveView.forbidden'));
      return;
    }
    let isValid = true;
    this.$refs[formName].validate((valid) => {
      if (!valid) {
        this.$message({
          message: this.$t('customerManagements.PleaseFillRequiredFieldsCorrectly'), // '请正确填写必填项'
          type: 'warning'
        });
        isValid = false;
        return false;
      }
    });
    if (!isValid) {
      return;
    }
    const ruleForm = this.setData();
    if (containsSensitivePlaceholder(ruleForm)) {
      this.$message.error(this.$t('sensitiveView.refresh'));
      return;
    }
    if (this.ruleForm.id) {
      // 编辑
      this.asyncUserEdit(ruleForm);
    } else {
      this.asyncUserAdd(ruleForm);
    }
  },
  setData() {
    const ruleForm = cloneDeep(this.ruleForm);
    // 证件照附件转为逗号分隔的 URL 字符串
    ruleForm.identityCardAttachment = (this.fileList || []).map((item) => item.url).join(',');
    ruleForm.password = this.pwd;
    // 选择个人，清空企业数据
    // if (ruleForm.source === 'person') {
    //   ruleForm.company = '';
    //   ruleForm.coPrincipalName = '';
    //   ruleForm.coPrincipalPhone = '';
    //   ruleForm.coPrincipalTel = '';
    //   ruleForm.coPrincipalEmail = '';
    //   ruleForm.coPrincipalQq = '';
    // }
    if (!ruleForm.handlerIdList) {
      ruleForm.handlerIdList = [];
    }
    // 新增时客户编号置为 null
    if (!this.ruleForm.id) {
      ruleForm.code = null;
    }
    return ruleForm;
  },
  resetForm() {
    this.fileList = [];
    this.disabled = false;
    this.syncSenderAddress = false;
    for (const key in this.ruleForm) {
      if (key === 'username' || key === 'integral' || key === 'id' || key === 'code') {
        this.disabled = true;
      } else {
        this.ruleForm[key] = '';
      }
    }
    this.ruleForm.source = 'corporation';
    this.ruleForm.auditState = 0;
    this.ruleForm.lockState = 1;
    this.ruleForm.integral = '0';
    if (this.activeNames.length >= 4) {
      this.disabled = false;
    }
  },
  resumeBeforeAvatarUpload(file) {
    const typeArr = [...imgTypeArr, ...pdfTypeArr];
    const { type, size } = file;
    // const isPDF = type === 'application/pdf';
    // console.log(1);
    const isType = typeArr.includes(type);

    const isLt5M = size / 1024 / 1024 < 5;
    if (!isType) {
      //                 上传只能是                                                        格式!
      this.$message.error(
        ` ${this.$t('customerManagements.UploadOnlyBe')}${typeArr.join('/')}${this.$t(
          'customerManagements.format'
        )} `
      );
    }
    if (!isLt5M) {
      this.$message.error(this.$t('customerManagements.sizeNoMoreThan2MB')); // '上传大小不能超过 2MB!'
    }
    return isType && isLt5M;
  },
  resumeUpload(option) {
    const version = this.sensitiveVersion;
    const identity = this.sensitiveIdentity;
    const id = this.ruleForm.id;
    const type = this.customerTypeSee.type;
    // 上传与查询共用生命周期，撤权或换记录后不能恢复附件，也不能清除新表单。
    const isCurrent = () => version === this.sensitiveVersion && identity === this.sensitiveIdentity &&
      id === this.ruleForm.id && type === this.customerTypeSee.type && !this.readonly &&
      (type === 'add' || (this.canEditSensitive && this.sensitiveReady));
    if (!isCurrent()) return;
    const { file } = option;
    return uploadOos(file, 'customer')
      .then((res) => {
        if (isCurrent() && res.code === 200) {
          const obj = {
            name: file.name,
            url: res.url
          };
          this.fileList = [...this.fileList, obj];
        }
      })
      .catch(() => {
        // 额外兜底：也清空当前组件内部文件残留
        if (isCurrent()) this.$refs.upload?.clearFiles();
      });
  }
};
